<template>
    <div>
        <header class="main-menu bg-white">
            <div class="left-links">
                <ul>
                    <li class="logo">
                        <a href="/offers">
                            <img src="images/new.svg" alt="Logo" >
                        </a>
                    </li>
                </ul>
            </div>

            <div v-if="show_login_button" onclick="location.href='/sign_in';" class="right-menu">
                <font-awesome-icon  icon="fa-solid fa-circle-user"  style="font-size: 3rem;color:#f26b1c"/>
                <a href="/sign_in"  style="color:#f26b1c;font-size:2rem ">&nbsp;Log in</a>

            </div>
            <div v-else class="right-menu">
                <points-copy-component v-if="!(hide_points_msg && hide_points_msg == true)" class="d-none d-md-block"></points-copy-component>
                <nav-bar-component></nav-bar-component>
            </div>
        </header>
        <points-copy-component v-if="!(hide_points_msg && hide_points_msg == true)" class="d-sm-block d-md-none bg-grey py-4 px-4 text-center"></points-copy-component>
    </div>
</template>

<script>
import PointsCopyComponent from './header/PointsCopyComponent.vue';
import NavBarComponent from './NavBarComponent.vue'
export default {
    components: { NavBarComponent, PointsCopyComponent },
    props:['show_login_button', 'hide_points_msg'],
    name: "HeaderComponent",
    mounted: function() {
        // Delegated + namespaced binding so the menu toggle works even when the
        // nav bar is rendered after the header mounts (e.g. auth resolves async on
        // the campaign landing page), and never stacks across SPA navigations.
        // State is read from the DOM so it survives the button being re-created.
        $(document).off('click.jsMenu').on('click.jsMenu', '.js-menu', function () {
            var willOpen = !$(this).hasClass('active');
            $(this).toggleClass('active', willOpen);
            $('body').toggleClass('menu-open', willOpen);
        });
    }
}
</script>
